import React from 'react';
import {connect} from 'react-redux';
import {ThunkDispatch} from 'redux-thunk';
import {AnyAction} from 'redux';

import {AppState} from '../Store';
import {setCategoryCreator} from '../Store/Home/Actions';

interface CategoryLinkProps {
  category: string;
  className?: string;
  title?: boolean;

  currentCategory: string;
  categoryUses: Record<string, number>;

  setCategory: (category: string) => Promise<void>;
}

function CategoryLink({
  category,
  className,
  title,

  currentCategory,
  categoryUses,

  setCategory,
}: CategoryLinkProps) {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setCategory(category);
  };

  let actualClass = className || '';
  if (category === currentCategory) {
    actualClass += ' selected';
  }

  const uses = categoryUses[category];
  const text = (title && uses !== undefined)
    ? `${category} (${uses})`
    : category;

  return (
    <a className={actualClass} onClick={handleClick} href={`/public/category/${category}`}>{text}</a>
  );
}

const mapStateToProps = (state: AppState) => {
  return {
    currentCategory: state.home.currentCategory,
    categoryUses: state.home.categoryUses,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    setCategory: (category: string) => dispatch(setCategoryCreator(category)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CategoryLink);
